import React from 'react';
import { Card as AntdCard } from 'antd';
import styles from './Card.module.scss';
import cx from 'clsx';

const Card = ({
  headerTitle = null,
  children,
  className,
  variant = '',
  footer,
  bordered = false,
  Extra = null,
  outerClassName = '',
  outerStyle = {},
  ...rest
}) => {
  return (
    <div className={cx(outerClassName, styles[variant])} style={outerStyle}>
      <AntdCard title={headerTitle} className={cx(className)} bordered={bordered} extra={Extra} {...rest}>
        {children && children}
        {footer && (
          <div id="card-footer" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
            {footer}
          </div>
        )}
      </AntdCard>
    </div>
  );
};

export default Card;
